"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { whyChooseCards } from "./crm.data";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
const MotionImage = motion.create(Image);
export default function WhyChooseUs() {
  const $ = _c(24);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins text-[1.9rem] sm:text-[2.25rem] lg:text-[2.5rem] font-bold text-[#141047] mb-5 leading-tight dark:text-white">Why Choose Us?</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-gray-500 text-base lg:text-lg mb-8 leading-relaxed max-w-lg dark:text-gray-400">Empowering your home services business with innovative, reliable, and user-friendly solutions, we ensure seamless experiences for both service providers and customers.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><GradientButton href="/contact" variant="peach-pink">Get a Free Consultation <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-12 flex justify-start"><MotionImage initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} src="/images/crm/why-choose.png" alt="Why choose The Dezine" width={480} height={360} className="animate-[float_4s_ease-in-out_infinite] w-full max-w-[480px] object-contain" /></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5) {
    t9 = <div className="flex flex-col justify-center relative">{t5}{t6}{t7}{t8}</div>;
    $[15] = t5;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== desktopAnimations) {
    t10 = whyChooseCards.map((card, idx) => <motion.div key={card.title} initial={desktopAnimations ? {
      opacity: 0,
      x: 40
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.5,
      delay: idx * 0.1,
      ease
    }} viewport={{
      once: true
    }} className="relative bg-white/70 backdrop-blur-md rounded-2xl p-5 pl-10 flex items-center gap-5 border border-white/50 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_36px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 ml-4 lg:ml-8 dark:bg-gray-800/80 dark:border-white/10 dark:shadow-[0_8px_30px_rgba(0,0,0,0.4)]"><div className="absolute -left-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center font-bold text-lg text-[#141047] border border-pink-200 shadow-sm dark:bg-gray-900 dark:border-gray-700"><span className="bg-clip-text text-transparent bg-gradient-to-r from-[#ffae86] to-[#ff4f94]">{idx + 1}</span></div><div className="w-14 h-14 shrink-0 flex items-center justify-center bg-[#f0f8ff] rounded-lg dark:bg-gray-800"><Image src={card.icon} alt={`${card.title} icon`} width={40} height={40} className="w-10 h-10 object-contain" /></div><div><h3 className="font-poppins text-lg font-bold text-[#141047] mb-1 leading-snug dark:text-white">{card.title}</h3><p className="text-gray-500 text-sm leading-relaxed dark:text-gray-400">{card.description}</p></div></motion.div>);
    $[17] = desktopAnimations;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <div className="flex flex-col gap-6 pl-0 lg:pl-6 pt-4 lg:pt-0">{t10}</div>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <section className="bg-gradient-to-b from-[#c7ecff] to-[#f9efff] py-16 md:py-24 px-6 font-sans overflow-hidden dark:from-gray-950 dark:to-gray-900"><div className="max-w-7xl mx-auto"><div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">{t9}{t11}</div></div></section>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}